export default (data: any) => (data === null || data === "" ? undefined : data);
